export function request(customerId) {
    return {
        type: 'CUSTOMERS_REFERAL_VALIDATION_REQUEST',
        customerId
    };
}

export function error(customerId, errors) {
    return {
        type: 'CUSTOMERS_REFERAL_VALIDATION_ERROR',
        customerId,
        errors
    };
}

export function finish(customerId, validation) {
    return {
        type: 'CUSTOMERS_REFERAL_VALIDATION_FINISH',
        customerId,
        validation
    };
}
